import React from 'react';
import './Posts.css';
import PropTypes from 'prop-types';
import PostItem from './PostItem';
import Pagination from '../common/Pagination/Pagination';


const Posts = ({posts, pages, page, setPage}) => {
  const postItems = posts.map((post, index) => (
    <PostItem
      key={index}
      title={post.title}
      slug={post.slug}
      excerpt={post.excerpt}
      date={post.date}
      image={post.image}
    />
  ));

  return (
    <div className="posts fade-in">
      <div className="d-flex flex-wrap justify-content-center p-sm-1 mw-1000 m-auto">
        {postItems}

      </div>

      {pages !== 1 &&
        <Pagination
          pages={pages}
          page={page}
          setPage={setPage}
        />
      }

    </div>
  );
};


Posts.propTypes = {
  posts: PropTypes.array.isRequired,
  pages: PropTypes.number.isRequired,
  page: PropTypes.number.isRequired,
  setPage: PropTypes.func.isRequired
};

export default Posts;



// WEBPACK FOOTER //
// ./src/components/Posts/Posts.js